import { FieldPickerField } from "../../components/field-picker/components/fields/fields.types";

export const resolveFieldsToAddOnDrop = ({
  draggedField,
  selectedFieldsInFieldPicker,
}: {
  draggedField?: FieldPickerField;
  selectedFieldsInFieldPicker: Array<FieldPickerField>;
}) => {
  if (!draggedField) {
    return selectedFieldsInFieldPicker;
  }

  const isDraggedFieldSelected = selectedFieldsInFieldPicker.some((field) => field.id === draggedField.id);

  if (isDraggedFieldSelected && selectedFieldsInFieldPicker.length > 1) {
    return selectedFieldsInFieldPicker;
  }

  return [draggedField];
};
